const signals = [
  'Original Artwork',
  'Custom Creations',
  'Handcrafted Designs',
  'Personalized to You',
];

const TrustBar = () => (
  <section className="w-full bg-[#080604] border-t border-white/[0.04] py-5 px-6 overflow-hidden">
    <div className="max-w-4xl mx-auto flex flex-wrap items-center justify-center gap-x-10 gap-y-3">
      {signals.map((s, i) => (
        <div key={s} className="flex items-center gap-10">
          <span className="text-white/20 text-[9px] uppercase tracking-[0.55em] font-light whitespace-nowrap">{s}</span>
          {i < signals.length - 1 && (
            <div className="hidden md:block w-px h-2.5 bg-white/[0.06]"></div>
          )}
        </div>
      ))}
    </div>
  </section>
);

export default TrustBar;
